import React, { createContext, useState, useEffect } from 'react';

const ValidationVideoLocalStorage = createContext();

export const ValidationVideoLocalStorageProvider = ({ children }) => {
  const [selectedFilePath, setSelectedFilePath] = useState('');
  const [programType, setProgramType] = useState('');
  const [audioAnalysisResults, setAudioAnalysisResults] = useState([]);
  const [audioAnalysisTime, setAudioAnalysisTime] = useState('');
  const [programs, setPrograms] = useState([]);
  const [selectedOperations, setSelectedOperations] = useState([]);
  const [language, setLanguage] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [fileName, setFileName] = useState('');
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [dots, setDots] = useState('');
  const [selectedFileObject, setSelectedFileObject] = useState(null);
  // All selected videos when several are chosen (selectedFileObject stays the first one)
  const [selectedFileObjects, setSelectedFileObjects] = useState([]);
  const [isCheckingCredits, setIsCheckingCredits] = useState(false);
  const [programId, setProgramId] = useState("");
  const [selectedProgramIds, setSelectedProgramIds] = useState([]);
  

  return (
    <ValidationVideoLocalStorage.Provider
      value={{
        selectedFilePath, setSelectedFilePath,
        programType, setProgramType,
        audioAnalysisResults, setAudioAnalysisResults,
        audioAnalysisTime, setAudioAnalysisTime,
        programs, setPrograms,
        selectedOperations, setSelectedOperations,
        language, setLanguage,
        alertMessage, setAlertMessage,
        fileName, setFileName,
        isAnalyzing, setIsAnalyzing,
        dots, setDots,
        selectedFileObject, setSelectedFileObject,
        selectedFileObjects, setSelectedFileObjects,
        isCheckingCredits, setIsCheckingCredits,
        programId, setProgramId,
        selectedProgramIds, setSelectedProgramIds
      }}
    >
      {children}
    </ValidationVideoLocalStorage.Provider>
  );
};

export default ValidationVideoLocalStorage;
